var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMipVectorWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.38266 11.5814H8.7698L8.34755 10.8839H5.67894L7.0119 8.67966L6.58965 7.98219L4.38266 11.5814ZM3.75823 10.8925H2.9504L1.58076 13.1395H11.6021C11.1476 12.3873 10.6923 11.636 10.2379 10.8839H9.38883C9.70291 11.403 10.0169 11.9229 10.3318 12.4419H2.82068L3.75823 10.8925ZM9.41037 6.38745L8.98628 7.08749L10.3408 9.32511H7.66317L7.24092 10.0226C8.69554 10.0226 10.1501 10.0226 11.6039 10.0226L9.41037 6.38745ZM8.46921 3.1058L6.59055 0L0 10.8925H1.9064C1.2757 11.9289 0.64322 12.9628 0.0152081 14H13.165L12.222 12.4419H16L9.41037 1.55034L8.46921 3.1058ZM9.41037 3.27142L14.438 11.5814H11.7014L11.2792 10.8839C11.908 10.8839 12.536 10.8839 13.1641 10.8839C11.9108 8.80855 10.6628 6.73577 9.41125 4.66467C9.09637 5.18543 8.78054 5.70705 8.46563 6.22781L8.04338 5.53033C8.49963 4.77651 8.95497 4.02439 9.41037 3.27142ZM6.58965 1.71083L7.94945 3.96463L7.52362 4.66894L6.59055 3.12628L2.835 9.33442H4.70204L4.27978 10.032H1.56288L6.58965 1.71083ZM6.58965 4.84736L4.39608 8.47307H5.22091L6.57981 6.22611C7.03158 6.9731 7.46905 7.71498 7.92261 8.46451H8.77785C8.106 7.35471 7.43505 6.24489 6.7641 5.13506L6.58965 4.84736Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMipVectorWhite);
export default __webpack_public_path__ + "static/media/MIPVectorWhite.71a4a2dff5bcbc9cd07d61642029e5ae.svg";
export { ForwardRef as ReactComponent };